import cnames from 'classnames'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'

const TerminalStatus = ({ isConnected, isConnecting }) => {
  const getStatusConfig = () => {
    if (isConnecting)
      return { statusClasses: 'text-muted ms-1', statusText: 'Connecting...' }

    if (isConnected)
      return { statusClasses: 'text-dark-green', statusText: 'Connected' }

    return { statusClasses: 'text-cardinal', statusText: 'Not Connected' }
  }

  const { statusClasses, statusText } = getStatusConfig()
  const textClasses = cnames('fst-italic', statusClasses)

  return (
    <div className="d-flex flex-column flex-sm-row mb-1">
      <span className="text-gray-600">Reader Status: </span>

      <div className={textClasses}>
        {!isConnecting && <FontAwesomeIcon className="mx-1 mt-1" icon="circle" size="2xs" />}

        {statusText}
      </div>
    </div>

  )
}

export default TerminalStatus
